import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        token: null,
        user: null,
    },
    reducers: {
        appStartUp: (state, action) => {
            state.user = action.payload
        },
        signIn: (state, action) => {
            state.user = action.payload
        },
        signOut: (state) => {
            state.user = null
        },
        setToken(state, action) {
            state.token = action.payload;
            console.log(state.token,"...")
          },
    }
})

export const { signIn, signOut, appStartUp, setToken } = authSlice.actions

export default authSlice.reducer